// extracted by mini-css-extract-plugin
export default {"landing":"landing_landing__3S6CD","content":"landing_content__0rg2C"};